export const DEFAULT = {
  ASSESSMENT: "0,0",
  ASSESSMENT_FLOAT: 0.0,
  TOTAL_ASSESSMENT: "0,000",
  ASSESSMENT_UNKNOWN: "--,--",
  ASSESSMENT_UNKNOWN_NEW_SMALL: "-,-",
  ASSESSMENT_UNKNOWN_HUGE: "-----,--",
};
